import { render, staticRenderFns } from "./XuCascader.vue?vue&type=template&id=1e3fb37c&scoped=true"
import script from "./XuCascader.vue?vue&type=script&lang=js"
export * from "./XuCascader.vue?vue&type=script&lang=js"
import style0 from "./XuCascader.vue?vue&type=style&index=0&id=1e3fb37c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3fb37c",
  null
  
)

export default component.exports